import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { FormControl } from '@common/components/form-control';
import { Button } from '@common/components/Button';
import debounce from 'lodash/debounce';

import * as newUserActions from '../actions/NewUserActions';
import * as ambryKeyActions from '../actions/AmbryKeysActions'
import UsersTableController from './UsersTableController';
import UserDetailsController from './UserDetailsController';
import NewUserWndController from './NewUserWndController';
import ChangePasswordWndController from './ChangePasswordWndController'
import UserMaintenanceMessageBoxController from './UserMaintenanceMessageBoxController';
import AmbryKeyDialogController from './AmbryKeyDialogController';
import { MessageBoxTypes } from '../const/ActionsConst';
import { showMessageBoxBasedOnData } from '../actions';
import { filterUsers } from '../actions/UsersTableActions';
import { getAppConfig } from '@common/utils/config';

import '../styles/UserMaintenance.scss';

class UserMaintenanceWnd extends Component {
    searchInputRef = React.createRef();
    appConfig = getAppConfig();

    search = () => {
        const { value } = this.searchInputRef.current;
        const { filterUsers } = this.props;

        filterUsers({ searchKeyword: value });
    }

    handleSearchSubmit = (e) => {
        e.preventDefault();

        this.search();
    }
    
    render () {
        const { user, selectedUsers, onUsersDelete } = this.props;
        const shouldRenderBulkActions = selectedUsers.length > 1;
        const shouldRenderUserDetails = Boolean(user.username) && !shouldRenderBulkActions;
        const userMaintenanceConfig = this.appConfig.userMaintenance;

        return  (
            <div className="container UserMaintenance" style={{width: '100%', marginLeft: '15px', height: '100%'}}>
                <div className="row">
                    <div className="col-md-12" style={{paddingTop: '10px', paddingBottom: '5px', paddingLeft: '0px'}}>
                        <div style={{color: '#008dce', fontSize: '22px', letterSpacing: '-0.5px'}}>
                            {I18n.t('User Maintenance')}
                        </div>
                    </div>
                    <div className="col-md-12 UserMaintenance__actions">
                        <i className="fa fa-search UserMaintenance__actions__search-icon" onClick={this.search} />
                        <form className="UserMaintenance__actions__search-form" onSubmit={this.handleSearchSubmit}>
                            <FormControl 
                                inputRef={this.searchInputRef}
                                className="UserMaintenance__actions__search-input" type="text"
                                onChange={userMaintenanceConfig.liveSearchEnabled
                                    ? debounce(this.search, userMaintenanceConfig.liveSearchDelay)
                                    : undefined
                                }
                            />
                        </form>
                        <div>
                            <button id="btn-new-user" className="btn btn-primary" style={{float: 'right', marginRight: '20px'}} onClick={this.props.addNewUser}>
                                <i className="fa fa-plus" aria-hidden="true" style={{paddingRight: '5px'}}></i>
                                {I18n.t('New User')}
                            </button>
                            <button id="btn-testing-keys" className="btn btn-default" style={{float: 'right', marginRight: '10px'}} onClick={this.props.showAmbryKeys}>
                                {I18n.t('Testing Keys')}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row UserMaintenance__container">
                    <div className="col-md-6 UserMaintenance__table">
                        <UsersTableController />
                    </div>
                    {shouldRenderUserDetails && (
                        <div className="col-md-6 UserMaintenance__details">
                            <UserDetailsController />
                        </div>
                    )}
                    {shouldRenderBulkActions && (
                        <div className="col-md-6 UserMaintenance__container__bulk-actions">
                            <Button id="btn-delete-users" onClick={onUsersDelete}>{I18n.t('Delete Users')}</Button>
                        </div>
                    )}
                </div>
                <NewUserWndController />
                <AmbryKeyDialogController />
                <ChangePasswordWndController />
                <UserMaintenanceMessageBoxController />
            </div>
        );
    }
}

UserMaintenanceWnd.propTypes = {
    addNewUser: PropTypes.func,
    showAmbryKeys: PropTypes.func,
    filterUsers: PropTypes.func,
};

const mapStateToProps = state => {
    return {
        ...state.userDetails,
        selectedUsers: state.usersTable.selectedUsers,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        filterUsers: (params) => dispatch(filterUsers(params)),
        addNewUser: () => dispatch(newUserActions.showNewUserWnd(true)),
        showAmbryKeys: () => dispatch(ambryKeyActions.showDialog(true)),
        onUsersDelete: () => dispatch(
            showMessageBoxBasedOnData(
                MessageBoxTypes.DELETE_MULTIPLE_USERS, 
                true, 
                I18n.t('Delete Users'), 
                I18n.t('Are you sure you want to delete all selected users?'), 
                I18n.t('Delete Users'),
                I18n.t('Cancel'), 
                'small'
            )
        ),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMaintenanceWnd);